import UserPammAccounts from './UserPammAccounts';

export default UserPammAccounts;
